import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import committies from "../../utils/committees.json";
import CommitteeTable from "../../components/committeeMembersComp/CommitteeTable";

type DataProps = {
  Incharge: string[];
  Members: string[];
};

const AntiRagging = () => {
  const fa: Array<DataProps> = [
    {
      Incharge: committies
        .find((obj) => obj.name.includes("Anti-ragging Committee"))
        ?.incharge[0].split("- ")[1]
        .split(",") as Array<string>,
      Members: committies
        .find((obj) => obj.name.includes("Anti-ragging Committee"))
        ?.incharge[1].split("- ")[1]
        .split(",") as Array<string>,
    },
  ];
  const titles = ["Sr.No.", "Incharge", "Members"];
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
      >
        <Typography fontSize={16}>
          Modern College of Physiotherapy maintains a strict zero-tolerance
          policy towards ragging. In compliance with the University Grants
          Commission (UGC) guidelines, the college has established a dedicated
          Anti-Ragging Committee. This committee comprises faculty members,
          administrative staff, and student representatives, working
          collaboratively to create a safe and conducive learning environment
          for all students. The committee proactively organizes anti-ragging
          awareness programs, workshops, and seminars to educate students about
          the legal and ethical implications of ragging. Additionally, the
          committee provides a confidential platform for students to report any
          incidents of ragging without fear of reprisal. Prompt and stringent
          action is taken against those found guilty of ragging, in accordance
          with the prescribed regulations. The college is committed to fostering
          a culture of respect, dignity, and academic excellence, where every
          student feels safe and empowered.
        </Typography>
        <Stack
          spacing={2}
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <Grid
            container
            textAlign="center"
            justifyContent={"center"}
            mt={{ xs: "16px !important", md: "32px !important" }}
          >
            <Grid item m={2}>
              <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                Anti-ragging Committee
              </Typography>
            </Grid>
            <Grid
              container
              sx={{
                justifyContent: "center",
                alignItems: "center",
                margin: "auto",
              }}
            >
              <CommitteeTable titles={titles} data={fa} />
            </Grid>
          </Grid>
        </Stack>
      </Stack>
    </Box>
  );
};

export default AntiRagging;
